"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalendarDatesClient = void 0;
const core_auth_1 = require("@deliverr/core-auth");
const AbstractTransitTimeClient_1 = require("./AbstractTransitTimeClient");
const defaultConfig = {
    authEngine: core_auth_1.AuthEngine.BASIC,
    prefix: "/calendar-dates",
    baseURL: process.env.TRANSIT_TIME_SERVICE_URL,
    basicAuthUser: process.env.TRANSIT_TIME_BASIC_AUTH_USER,
    basicAuthPassword: process.env.TRANSIT_TIME_BASIC_AUTH_PASSWORD,
};
class CalendarDatesClient extends AbstractTransitTimeClient_1.AbstractTransitTimeClient {
    constructor(config = {}) {
        const clientConfig = Object.assign(Object.assign({}, defaultConfig), config);
        super(clientConfig);
    }
    async getGroundShipMethodToZipsByDeliveryDate(request) {
        const { fromZip, maxDeliveryDays, shipDate, otdLevel, regionalShipMethods, zipDigits, includeDasZips, predictionId, hubIds, } = request;
        return this.getCached(`${this.prefix}/v1/transit/calendar-dates/${maxDeliveryDays}`, {
            fromZip,
            shipDate,
            regionalShipMethods,
            zipDigits,
            otdLevel,
            includeDasZips,
            predictionId,
            hubIds,
        });
    }
}
exports.CalendarDatesClient = CalendarDatesClient;
//# sourceMappingURL=CalendarDatesClient.js.map